import { ref, computed } from 'vue';

import Validators from '@/api/Validators';

export function useFormSimpleOptions(formState) {
	return ref({
		isProtocolSecureRequired: computed(() => Validators.isProtocolSecureRequired(formState)),
		isProtocolSecureHelpVisible: computed(() => Validators.isProtocolSecureHelpVisible(formState)),
		isHostRequired: computed(() => Validators.isHostRequired(formState)),
		isPortRequired: computed(() => Validators.isPortRequired(formState)),
		isMntpntSrcRequired: computed(() => Validators.isMntpntSrcRequired(formState)),
		isCredentialsRequired: computed(() => Validators.isCredentialsRequired(formState)),
		isRequestVisible: computed(() => Validators.isRequestVisible(formState)),
		isRemoteAddressVisible: computed(() => Validators.isRemoteAddressVisible(formState)),
		isCasterAddressVisible: computed(() => Validators.isCasterAddressVisible(formState)),
		secureProtocolOptions: computed(() => Validators.getSecureProtocolOptions(formState)),
	});
}
